// import http, { ensureCsrfCookie } from './http'

// export async function register(name: string, email: string, password: string, password_confirmation: string) {
//   await ensureCsrfCookie()
//   const response = await http.post('/register', { name, email, password, password_confirmation })
//   return response.data
// }

// export async function login(email: string, password: string) {
//   await ensureCsrfCookie()
//   await http.post('/login', { email, password })
//   return me()
// }

// export async function logout() {
//   await ensureCsrfCookie()
//   await http.post('/logout')
// }

// export async function resendVerification() {
//   await ensureCsrfCookie()
//   await http.post('/email/verification-notification')
// }

// export async function me() {
//   const res = await http.get('/api/user', { params: { t: Date.now() } }).catch(() => ({ data: null }))
//   return res.data
// }

// export async function requestPasswordReset(email: string) {
//   await ensureCsrfCookie()
//   const { data } = await http.post('/api/auth/forgot-password', { email })
//   return data as { ok: boolean; status: string; message: string }
// }

// export async function resetPassword(
//   token: string,
//   email: string,
//   password: string,
//   password_confirmation: string
// ) {
//   await ensureCsrfCookie()
//   const { data } = await http.post('/reset-password', {
//     token,
//     email,
//     password,
//     password_confirmation,
//   })
//   return data as { ok: boolean; status?: string; message: string }
// }

// frontend/src/services/auth.ts
// frontend/src/services/auth.ts
import http, { ensureCsrfCookie } from './http'

let pendingMeRequest: Promise<any> | null = null
let meCache: any = null
let meCacheExpiresAt = 0 // timestamp ms

export async function register(name: string, email: string, password: string, password_confirmation: string) {
  await ensureCsrfCookie()
  const response = await http.post('/register', { name, email, password, password_confirmation })
  return response.data
}

export async function login(email: string, password: string) {
  await ensureCsrfCookie()
  await http.post('/login', { email, password })
  return me(true)
}

export async function logout() {
  await ensureCsrfCookie()
  await http.post('/logout')
  // clear local caches after logout
  meCache = null
  meCacheExpiresAt = 0
}

export async function resendVerification() {
  await ensureCsrfCookie()
  await http.post('/email/verification-notification')
}

/**
 * الحصول على بيانات المستخدم (me)
 * - force: إذا true يتجاهل الكاش ويجلب جديداً
 * - يستخدم dedupe لمنع طلبات متزامنة مكررة
 */
export async function me(force = false): Promise<any> {
  // لو في كاش صالح و ليس force => أعد النتيجة فوراً
  const now = Date.now()
  if (!force && meCache && now < meCacheExpiresAt) {
    return meCache
  }

  // لو هناك طلب جارٍ بالفعل، أعد نفس الوعد (dedupe)
  if (pendingMeRequest) {
    return pendingMeRequest
  }

  // إعداد طلب جديد
  pendingMeRequest = (async () => {
    try {
      // طلب CSRF أولاً (بعض حالات التزامن في dev تحتاجه)
      try { await ensureCsrfCookie() } catch (e) { /* ignore */ }

      const res = await http.get('/api/user', { params: { t: Date.now() } })
      meCache = res.data
      // كاش قصير (30 ثانية) — عدل القيمة إن رغبت (مؤقت أثناء تصحيح المشكلة)
      meCacheExpiresAt = Date.now() + 30 * 1000

      // DEBUG: لمعرفة المكونات التي تستدعي me() بكثرة (أزل هذا لاحقاً)
      if (process.env.NODE_ENV !== 'production') {
        const stack = (new Error()).stack || ''
        const snippet = stack.split('\n').slice(2, 6).map(s => s.trim()).join(' | ')
        console.debug('[me] fetched @', new Date().toISOString(), { snippet })
      }

      return meCache
    } catch (err) {
      // على خطأ، نفرغ الكاش ونرجع null (أو رمي الخطأ إن أردت)
      meCache = null
      meCacheExpiresAt = 0
      if (process.env.NODE_ENV !== 'production') {
        console.debug('[me] error', err)
      }
      // رمي لكي تبقى سلوكيات الخطأ حالياً كما هي في بقية التطبيق
      throw err
    } finally {
      // أزل المرجع للطلب الجاري
      pendingMeRequest = null
    }
  })()

  return pendingMeRequest
}

export async function requestPasswordReset(email: string) {
  await ensureCsrfCookie()
  const { data } = await http.post('/api/auth/forgot-password', { email })
  return data as { ok: boolean; status: string; message: string }
}

export async function resetPassword(
  token: string,
  email: string,
  password: string,
  password_confirmation: string
) {
  await ensureCsrfCookie()
  const { data } = await http.post('/reset-password', {
    token,
    email,
    password,
    password_confirmation,
  })
  return data as { ok: boolean; status?: string; message: string }
}




